import { useEffect, useState } from "react";

import { Card } from "../../../components/Card";

import { api } from "../../../services/api";
import { AxiosError } from "axios";
import { AddButton } from "../../../components/atoms/Button/AddButton";
import { ButtonListButton } from "../../../components/organisms/ButtonListBox";
import { useNavigate } from "react-router-dom";
import { EditButton } from "../../../components/molecules/EditButton";
import { DeleteModal } from "../../../components/templates/DeleteModal";
import { useAuth } from "../../../hooks/auth";
import { useQuery } from "../../../hooks/query";
import { Table } from "../../../components/templates/Table";

interface AccountPlan {
  id: string;
  name: string;
  description: string;
}

interface Params {
  page: number;
  limit_per_page: number;
  search: string;
  order_column?: string;
  order_type?: string;
}

export function ListAccountPlans() {
  const query = useQuery();

  const { user } = useAuth();
  const navigate = useNavigate();
  const [accountPlans, setAccountPlans] = useState<AccountPlan[]>([]);

  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState<number>(0);
  const [defaultParams, setDefaultParams] = useState<Params>({
    limit_per_page: query.get("limit") ? Number(query.get("limit")) : 10,
    page: query.get("offset") ? Number(query.get("offset")) : 1,
    search: query.get("search") ?? "",
    order_column: query.get("order_column") ?? "",
    order_type: query.get("order_type") ?? "",
  });
  useEffect(() => {
    api
      .get(
        `accountPlans/pagination?offset=${defaultParams.page}&limit=${defaultParams.limit_per_page}&search=${defaultParams.search}&order_column=${defaultParams.order_column}&order_type=${defaultParams.order_type}`
      )
      .then((response) => {
        setAccountPlans(response.data.accountPlans);
        setTotal(response.data.total);
        setLoading(true);
      })
      .catch((err: AxiosError) => {
        navigate(`/error/${err.response?.status}`);
      });
  }, [
    defaultParams.limit_per_page,
    defaultParams.order_column,
    defaultParams.order_type,
    defaultParams.page,
    defaultParams.search,
    navigate,
    user.company_id,
  ]);
  return (
    <>
      <Card
        border="#216ca5"
        title="Planos de Conta"
        header={<AddButton link="/plano-de-conta/cadastrar" />}
        body={
          <Table
            loading={loading}
            message="Buscando os planos de contas"
            params={defaultParams}
            setDefaultParams={(params) => {
              setDefaultParams(params);
              navigate(
                `/planos-de-conta?offset=${params.page}&limit=${params.limit_per_page}&search=${params.search}&order_column=${params.order_column}&order_type=${params.order_type}`
              );
            }}
            total={total}
            data={accountPlans.map((accountPlan) => {
              return {
                tr: [
                  {
                    name: accountPlan.name,
                  },
                  {
                    name: accountPlan.description,
                  },
                  {
                    name: (
                      <ButtonListButton>
                        <EditButton
                          link={`/plano-de-conta/${accountPlan.id}`}
                        />
                        <DeleteModal
                          onDelete={(id) => {
                            setAccountPlans(
                              accountPlans.filter(
                                (accountPlan) => accountPlan.id !== id
                              )
                            );
                          }}
                          id={accountPlan.id}
                          route="accountPlans/"
                          error_message="Não foi possível remover o plano de conta"
                          success_message="Plano de conta removido com sucesso"
                        />
                      </ButtonListButton>
                    ),
                  },
                ],
              };
            })}
            columns={[
              {
                name: "name",
                label: "Nome",
                options: {
                  sort: true,
                },
              },
              {
                name: "description",
                label: "Descrição",
                options: {
                  sort: true,
                },
              },
              {
                name: "action",
                label: "Ações",
                options: {
                  sort: false,
                },
              },
            ]}
          />
        }
      />
    </>
  );
}
